<template>
    <div>
        <vs-button v-on:click="$router.push(`/admin/members/user?uuid=${params.data.uuid}`).catch(() => {})"
                   class="text-bold">
            Go to overview
        </vs-button>
    </div>
</template>

<script>
export default {
    name: 'CellRendererOverview',
}
</script>
